@if (loading) {
  <wpp-piston-loader size="15rem" centered />
} @else {
  <core-ui-row [justify]="'center'" class="mb-5 appointment-row">
    <core-ui-card
      class="appointment-card appointment-card--narrow"
      [title]="'wpp.common.appointment.plan-title' | translate"
    >
      @if (serverError) {
        <core-ui-alert [type]="'danger'" [hasIcon]="false" [text]="serverError" />
      }

      @if (lastTwoDigits()) {
        <core-ui-text>
          {{ 'wpp.page.authenticate.intro' | translate }}
          <span class="fw-bold">{{
            'wpp.page.authenticate.phone-hint' | translate: { lastTwoDigits: lastTwoDigits() ?? '' }
          }}</span>
          @if (hasResendCodeRequest) {
            <core-ui-icon icon="check-circle" class="text-success" />
          }
        </core-ui-text>
      }

      <form
        [formGroup]="authForm"
        class="d-flex flex-column mt-5"
        (keydown.enter)="onEnterSubmit()"
        (paste)="onPaste($event)"
      >
        <core-ui-form-group [formArray]="validationCodes">
          <div class="d-flex gap-2">
            @for (field of validationCodes.controls; track field) {
              <core-ui-text-input
                wppNumericInput
                [classes]="'text-center text-input-' + $index"
                [hasError]="authForm.get('validationCodes.' + $index)?.invalid && submitted"
                #authFields
                (keydown)="onKeyDown($event, $index)"
                [class]="'auth-input-' + $index"
                [maxLength]="1"
                [formControlName]="$index"
              />
            }
          </div>

          @if (hasError) {
            <core-ui-validation-feedback
              validation-feedback
              [message]="'wpp.page.authenticate.validation.code-invalid' | translate"
            />
          }

          @if (!isSubmitting && submitted && !hasSilentApiResponseError) {
            <div validation-feedback>
              {{ 'wpp.page.authenticate.resend.prompt' | translate }}
              <core-ui-button
                [attr.title]="'wpp.page.authenticate.resend.title' | translate"
                buttonStyle="link"
                (buttonClick)="sendNewCode($event, email)"
              >
                {{ 'wpp.page.authenticate.resend.label' | translate }}
              </core-ui-button>
            </div>
          }

          @if (hasSilentApiResponseError) {
            <core-ui-validation-feedback validation-feedback>
              {{ 'wpp.page.authenticate.code-expired' | translate }}
              <core-ui-button
                [attr.title]="'wpp.page.authenticate.resend.title' | translate"
                buttonStyle="link"
                (buttonClick)="sendNewCode($event, email)"
              >
                {{ 'wpp.page.authenticate.resend.label' | translate }}
              </core-ui-button>
            </core-ui-validation-feedback>
          }
        </core-ui-form-group>
      </form>
      <div card-footer>
        <div class="d-flex flex-wrap align-items-center gap-2">
          <core-ui-button
            (buttonClick)="backToEmail()"
            style="white-space: nowrap"
            [buttonStyle]="'outlineSecondary'"
          >
            <core-ui-icon icon="arrow-left" /> {{ 'wpp.common.action.back' | translate }}
          </core-ui-button>
          <core-ui-button
            [classes]="'w-100'"
            class="authenticate__submit"
            buttonStyle="secondary"
            [attr.title]="'wpp.page.authenticate.submit.title' | translate"
            (buttonClick)="onSubmit()"
          >
            {{ 'wpp.page.authenticate.submit.label' | translate }}
            <core-ui-icon icon="arrow-right" />
          </core-ui-button>
        </div>

        <core-ui-text class="mt-5">
          {{ 'wpp.page.authenticate.guest.prefix' | translate }}
          <core-ui-button
            [attr.title]="'wpp.page.authenticate.guest.title' | translate"
            (buttonClick)="continueWithoutLogin()"
            buttonStyle="link"
          >
            {{ 'wpp.page.authenticate.guest.label' | translate }} </core-ui-button
          >.
        </core-ui-text>
      </div>
    </core-ui-card>
  </core-ui-row>
}
